module.exports = __webpack_public_path__ + "img/309f4dc02546fb88ab138a278bf73d0f.svg";